import OktaAuth from "@okta/okta-auth-js";
import { jwtDecode } from "jwt-decode";
import { store } from "../../store/store";
import { oktaConfig, oktaExternalConfig } from "./Okta.Config";

const oktaAuthInt = new OktaAuth(oktaConfig);

const oktaAuthExt = new OktaAuth(oktaExternalConfig);


const getStoreRef = () => {

    let storeRef: any = {};
    try {
        return storeRef.getState()?.oktaAuth?.isInternalUser ? oktaAuthInt : oktaAuthExt;
    } catch (error) {
        console.log("Store has not been initialized")
    }
    return oktaAuthExt;
}

const oktaAuth = getStoreRef();

const isTokenExpired = (token: any) => {
    if (!token || token === 'undefined') {
        return true;
    }

    const { exp } = jwtDecode(token);

    const currentTime = (Date.now() + 5 * 60 * 1000) / 1000;

    return exp && exp < currentTime;
}

const generateNewToken = async () => {

    const oktaAuthObj = store?.getState()?.oktaAuth?.isInternalUser ? oktaAuthInt : oktaAuthExt;

    try {
        const authTokens = await oktaAuthObj.token.getWithoutPrompt({
            responseType: ['id_token', 'token'],
            scopes: oktaConfig.scopes,
            prompt: 'none'
        });

        oktaAuthObj.tokenManager.setTokens(authTokens.tokens);
        console.log("Token renewed behind the scene", authTokens);
        return authTokens?.tokens?.accessToken?.accessToken;
    } catch (err) {
        console.log("Token failed to renewed", err);
        oktaAuthObj.signInWithRedirect();
    }
}

export { generateNewToken, isTokenExpired, oktaAuth };
